import { createReducer, on } from '@ngrx/store';

import * as actions from './se-header-toolbar.actions';
import { seHeaderToolbarInitialState } from './se-header-toolbar.state';

export const seHeaderToolbarReducer = createReducer(
    seHeaderToolbarInitialState,
    on(actions.seHeaderToolbarSetIsNavigateOnClickEnabled, (state, action) => ({
        ...state,
        isNavigateOnClickEnabled: action.enable,
    })),
);
